/*
 * marking-labels/codes.js — коды маркировки «Честного ЗНАКа»: прочитать
 * любую запись, восстановить разделители, проверить партию.
 *
 * ЧТО ЛОМАЕТСЯ В ЖИЗНИ (research 02, разборы обращений /barcode-*)
 * ──────────────────────────────────────────────────────────────────
 * Полный код маркировки — это GS1-строка: 01 + GTIN(14), 21 + серийный номер,
 * затем «криптохвост» — 91 + ключ(4) и 92 + код проверки(44) или короткий
 * 93 + код проверки(4). Между полями переменной длины стоит НЕВИДИМЫЙ символ
 * GS (ASCII 29). Его теряет почти всё, через что код проходит: Блокнот,
 * Word, мессенджеры, адресная строка, сканер-клавиатура, Excel; сканер в
 * русской раскладке вдобавок превращает латиницу в кириллицу. Без GS касса
 * и ЧЗ не разберут код — а напечатать его на этикетку можно и «неправильно».
 *
 * У каждой товарной группы ДЛИНЫ полей фиксированы (markirovka.ru, «Состав
 * кода маркировки», сверено 21.10.2026), поэтому по общей длине строки и по
 * тому, что на нужных местах стоят «91»/«92»/«93», разделители
 * восстанавливаются однозначно — без угадывания. Это и делает `parse()`.
 *
 * Канонический вид кода в этом модуле: БЕЗ ведущего FNC1/AIM, разделители —
 * настоящий байт 0x1D, только после полей переменной длины и не в конце.
 * Ровно эту строку кодирует GS1 DataMatrix (label-maker/matrix.js) и ровно её
 * отдаёт сканер (ZXing, textMode Plain) — поэтому сверка «напечатали →
 * прочитали» сравнивает строки один в один.
 *
 * Чистый модуль: без DOM. Тесты — tests/js/marking-labels-codes.test.mjs.
 */
(function (root, factory) {
    'use strict';
    var api = factory();
    if (typeof module !== 'undefined' && module.exports) module.exports = api;
    if (root) root.MarkingCodes = api;
})(typeof self !== 'undefined' ? self : (typeof window !== 'undefined' ? window : null), function () {
    'use strict';

    var GS = '\x1d';

    /* ── состав кода по группам ──────────────────────────────────────────────
     * [AI, длина]. Источник — markirovka.ru/knowledge/tovarnye-gruppy/<группа>/
     * sostav-koda-markirovki-*, сверено 21.10.2026 (таблица — docs/marking-labels.md).
     * `groups` — ключи групп, у которых бывает такой состав (подписи — в
     * переводах). `maxModule` — потолок модуля DataMatrix самой строгой из
     * этих групп: 0,615 мм у лёгкой промышленности, обуви, духов, шин и
     * фототехники, 0,68 мм у остальных. */
    var TEMPLATES = [
        { id: 'L83', fields: [['01', 14], ['21', 13], ['91', 4], ['92', 44]], maxModule: 0.615,
          groups: ['lp', 'shoes', 'perfume', 'tyres', 'bikes', 'furs', 'toys', 'home', 'ends', 'grocery', 'oils', 'sweets', 'meat', 'vet', 'bad', 'antiseptic', 'sportfood', 'medical', 'wheelchairs', 'tsr', 'motor_oils', 'building', 'cables', 'fiber', 'fertilizers'] },
        { id: 'L76', fields: [['01', 14], ['21', 6], ['91', 4], ['92', 44]], maxModule: 0.68,
          groups: ['canned', 'caviar', 'petfood', 'cosmetics', 'heating', 'pipes'] },
        { id: 'L90', fields: [['01', 14], ['21', 20], ['91', 4], ['92', 44]], maxModule: 0.615,
          groups: ['photo', 'electronics'] },
        // Обувь: страница ЧЗ пишет «четвёртая группа — 88 символов»; так же выглядят старые коды лекарств.
        { id: 'L127', fields: [['01', 14], ['21', 13], ['91', 4], ['92', 88]], maxModule: 0.615,
          groups: ['shoes', 'drugs_legacy'] },
        { id: 'L83w', fields: [['01', 14], ['21', 13], ['91', 4], ['92', 44], ['3103', 6]], maxModule: 0.68,
          groups: ['meat'] },
        { id: 'S37', fields: [['01', 14], ['21', 13], ['93', 4]], maxModule: 0.68,
          groups: ['water', 'soft_drinks', 'titanium', 'grocery', 'oils', 'ends', 'bad', 'antiseptic', 'sportfood', 'motor_oils', 'building', 'cables', 'fiber', 'fertilizers'] },
        { id: 'S30', fields: [['01', 14], ['21', 6], ['93', 4]], maxModule: 0.68,
          groups: ['dairy', 'toys', 'home', 'sweets', 'canned', 'meat', 'caviar', 'petfood', 'cosmetics', 'heating', 'pipes'] },
        { id: 'S30w', fields: [['01', 14], ['21', 6], ['93', 4], ['3103', 6]], maxModule: 0.68,
          groups: ['dairy', 'meat'] },
        { id: 'S31', fields: [['01', 14], ['21', 7], ['93', 4]], maxModule: 0.68,
          groups: ['beer', 'nabeer'] },
        { id: 'S31v', fields: [['01', 14], ['21', 7], ['93', 4], ['335*', 6]], maxModule: 0.68,
          groups: ['beer'] },
        { id: 'S44', fields: [['01', 14], ['21', 20], ['93', 4]], maxModule: 0.68,
          groups: ['electronics'] },
        // Блок сигарет: МРЦ (8005, копейки) между серийным и кодом проверки.
        { id: 'T41', fields: [['01', 14], ['21', 7], ['8005', 6], ['93', 4]], maxModule: 0.68,
          groups: ['tobacco_block'] },
    ];

    /* Поля, после которых GS обязателен, если за ними что-то идёт. По GS1:
     * всё, чего нет в таблице «предопределённой длины» (00–04, 11–20, 23,
     * 31–36, 41). 8005 — фиксированные 6 цифр, но в ту таблицу не входит. */
    function needsSeparator(ai) {
        return !/^(0[0-4]|1[1-9]|20|23|3[1-6]\d\d|41)$/.test(ai.length > 2 && /^3[1-6]/.test(ai) ? ai : ai.slice(0, 2)) || ai === '8005';
    }

    /* Известные AI для разбора кода, в котором GS уже стоят. */
    var FIXED = { '01': 14, '02': 14, '11': 6, '13': 6, '15': 6, '17': 6, '422': 3, '8005': 6 };
    var VARIABLE = { '10': 20, '21': 20, '240': 30, '91': 90, '92': 90, '93': 90, '94': 90 };

    function aiAt(s, i) {
        var a4 = s.substr(i, 4), a3 = s.substr(i, 3), a2 = s.substr(i, 2);
        if (a4 === '8005') return { ai: a4, len: 6, fixed: true };
        if (/^3[1-6]\d\d$/.test(a4)) return { ai: a4, len: 6, fixed: true };
        if (FIXED[a3] != null) return { ai: a3, len: FIXED[a3], fixed: true };
        if (VARIABLE[a3] != null) return { ai: a3, len: VARIABLE[a3], fixed: false };
        if (FIXED[a2] != null) return { ai: a2, len: FIXED[a2], fixed: true };
        if (VARIABLE[a2] != null) return { ai: a2, len: VARIABLE[a2], fixed: false };
        return null;
    }

    /* ── контрольная цифра GTIN ─────────────────────────────────────────── */
    function gtinCheckDigit(body) {
        var sum = 0, n = body.length;
        for (var i = 0; i < n; i++) {
            var d = body.charCodeAt(n - 1 - i) - 48;
            sum += (i % 2 === 0) ? d * 3 : d;
        }
        return (10 - (sum % 10)) % 10;
    }
    function gtinValid(g) {
        if (!/^\d{8}$|^\d{12,14}$/.test(g)) return false;
        return gtinCheckDigit(g.slice(0, -1)) === +g[g.length - 1];
    }

    /* ── запись GS в любом виде → настоящий байт ──────────────────────────
     * Всё, чем люди и программы пишут невидимый разделитель. '<GS>' формально
     * состоит из допустимых знаков GS1, но в настоящем серийном номере такая
     * последовательность не встречается; остальные записи используют знаки,
     * которых в наборе GS1 нет вовсе ('{', '[', '^', '~', '\', '␝', '#').
     * Одиночная «^» — так GS пишут шаблоны ZPL и часть выгрузок; «&#29;» —
     * GS, прошедший через HTML/XML (QA 23.10.2026). Обе однозначны: ни «^»,
     * ни «#» в серийном номере не бывает. */
    var GS_NOTATIONS = /\\x1d|\\u001d|\\035|\\0?29(?![0-9])|\^029|\^\]|~1|<GS>|\{GS\}|\[GS\]|<FNC1>|\{FNC1\}|\[FNC1\]|&#0*29;|&#x0*1d;|␝|↔|\^/gi;

    /* Сканер в русской раскладке печатает «0104…21Ахщ…» вместо «0104…21Fx[o…».
     * Раскладка ЙЦУКЕН → QWERTY — однозначное отображение клавиш, поэтому код,
     * набранный целиком в русской раскладке, восстанавливается точно. */
    var RU_TO_EN = (function () {
        var ru = 'йцукенгшщзхъфывапролджэячсмитьбюёЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮЁ"№;:?.,/';
        var en = 'qwertyuiop[]asdfghjkl;\'zxcvbnm,.`QWERTYUIOP{}ASDFGHJKL:"ZXCVBNM<>~@#$^&/?|';
        var m = {};
        for (var i = 0; i < ru.length; i++) m[ru[i]] = en[i];
        return m;
    })();
    function fromRuLayout(s) {
        var out = '';
        for (var i = 0; i < s.length; i++) out += RU_TO_EN[s[i]] != null ? RU_TO_EN[s[i]] : s[i];
        return out;
    }

    /* Одна запись кода → строка с настоящими GS и список того, что пришлось
     * поправить (для честного «что мы сделали с вашими данными»). */
    function normalize(input) {
        var notes = [];
        var s = String(input == null ? '' : input);
        s = s.replace(/[\uFEFF\u200B-\u200D\u2060]/g, '');
        if (/^\s*\][A-Za-z]\d/.test(s)) { s = s.replace(/^\s*\][A-Za-z]\d/, ''); notes.push('aim_removed'); }
        var before = s;
        s = s.replace(GS_NOTATIONS, GS);
        if (s !== before) notes.push('gs_notation');
        // Кавычки CSV вокруг всей записи.
        var t = s.trim();
        if (t.length > 2 && t[0] === '"' && t[t.length - 1] === '"' && /^"0?1/.test(t)) {
            t = t.slice(1, -1).replace(/""/g, '"');
            notes.push('csv_quotes');
        }
        s = t;
        if (/\s/.test(s)) {
            // Пробел внутри кода не бывает (набор GS1 его не содержит), а вот
            // «01 04601234567893 21 …» с этикетки и пробел вместо GS — бывают.
            s = s.replace(/\s+/g, '');
            notes.push('whitespace_removed');
        }
        s = s.replace(/\x1d{2,}/g, GS).replace(/^\x1d+/, '').replace(/\x1d+$/, '');
        return { raw: s, notes: notes };
    }

    /* ── разбор ─────────────────────────────────────────────────────────── */

    /* Строка без разделителей, разобранная по шаблону группы: длины
     * фиксированы, значит каждое поле начинается в известном месте, и там
     * обязан стоять его AI. */
    function matchTemplate(flat, tpl) {
        var pos = 0, out = [];
        for (var i = 0; i < tpl.fields.length; i++) {
            var f = tpl.fields[i], ai = f[0], len = f[1];
            var head;
            if (ai === '335*') {
                head = flat.substr(pos, 4);
                if (!/^335[0-6]$/.test(head)) return null;
                ai = head;
            } else {
                head = flat.substr(pos, ai.length);
                if (head !== ai) return null;
            }
            pos += ai.length;
            var v = flat.substr(pos, len);
            if (v.length !== len) return null;
            if (v.indexOf(GS) >= 0) return null;
            out.push({ ai: ai, value: v });
            pos += len;
        }
        if (pos !== flat.length) return null;
        if (!/^\d{14}$/.test(out[0].value)) return null;
        for (var k = 0; k < out.length; k++) {
            if ((out[k].ai === '8005' || /^3/.test(out[k].ai)) && !/^\d+$/.test(out[k].value)) return null;
        }
        return out;
    }

    /* Код, в котором GS уже стоят, — разбор по AI. null, если строка не
     * разбирается целиком. */
    function parseWithSeparators(s) {
        var pos = 0, out = [], guard = 0;
        while (pos < s.length && guard++ < 20) {
            while (s[pos] === GS) pos++;
            if (pos >= s.length) break;
            var a = aiAt(s, pos);
            if (!a) return null;
            pos += a.ai.length;
            var v;
            if (a.fixed) {
                v = s.substr(pos, a.len);
                if (v.length !== a.len || v.indexOf(GS) >= 0) return null;
                pos += a.len;
            } else {
                var g = s.indexOf(GS, pos);
                v = g < 0 ? s.slice(pos) : s.slice(pos, g);
                pos = g < 0 ? s.length : g;
                if (!v.length) return null;
            }
            out.push({ ai: a.ai, value: v });
        }
        return out.length ? out : null;
    }

    /* Форма «(01)04601234567893(21)…(91)…(92)…». Скобки внутри серийного
     * номера и кода проверки бывают, поэтому сперва — по шаблонам (места
     * известны), и только потом — общим разбором по скобкам. */
    function fromParenthesized(s) {
        if (!/^\(01\)\d{14}/.test(s)) return null;
        for (var i = 0; i < TEMPLATES.length; i++) {
            var tpl = TEMPLATES[i], pos = 0, out = [], ok = true;
            for (var j = 0; j < tpl.fields.length && ok; j++) {
                var ai = tpl.fields[j][0], len = tpl.fields[j][1];
                var m = /^\((\d{2,4})\)/.exec(s.slice(pos));
                if (!m) { ok = false; break; }
                if (ai === '335*' ? !/^335[0-6]$/.test(m[1]) : m[1] !== ai) { ok = false; break; }
                pos += m[0].length;
                var v = s.substr(pos, len);
                if (v.length !== len) { ok = false; break; }
                out.push({ ai: m[1], value: v });
                pos += len;
            }
            if (ok && pos === s.length) return out;
        }
        // Общий случай: каждая «(NN)» с известным AI — граница поля.
        var parts = s.split(/\((\d{2,4})\)/), fields = [];
        for (var k = 1; k < parts.length; k += 2) {
            if (!aiAt(parts[k] + '0000000000', 0)) return null;
            fields.push({ ai: parts[k], value: parts[k + 1] || '' });
        }
        return fields.length ? fields : null;
    }

    function joinFields(fields) {
        var s = '';
        for (var i = 0; i < fields.length; i++) {
            s += fields[i].ai + fields[i].value;
            if (i < fields.length - 1 && needsSeparator(fields[i].ai)) s += GS;
        }
        return s;
    }

    function templateOf(fields) {
        for (var i = 0; i < TEMPLATES.length; i++) {
            var tf = TEMPLATES[i].fields;
            if (tf.length !== fields.length) continue;
            var ok = true;
            for (var j = 0; j < tf.length && ok; j++) {
                var ai = tf[j][0];
                if (ai === '335*' ? !/^335[0-6]$/.test(fields[j].ai) : ai !== fields[j].ai) ok = false;
                else if (fields[j].value.length !== tf[j][1]) ok = false;
            }
            if (ok) return TEMPLATES[i];
        }
        return null;
    }

    /* Разобрать ОДНУ запись. Возвращает:
     *   { ok, input, code (канонический, с GS), fields, gtin, serial, ki,
     *     key91, check92, check93, structure (id шаблона), template,
     *     issues: [{code, level}] , level: 'ok'|'warn'|'error' }
     * `ok` — можно печатать. */
    /* Код в Base64 — так его хранит 1С и так он лежит в колонке нашей же выгрузки.
       Принимаем, только если раскодированное — код (01 + 14 цифр + 21…):
       обычная строка из латиницы и цифр Base64 тоже «похожа». */
    function fromBase64(s) {
        var t = String(s == null ? '' : s).trim();
        if (t.length < 40 || t.length % 4 !== 0 || !/^[A-Za-z0-9+\/]+={0,2}$/.test(t)) return null;
        var bin;
        try {
            if (typeof atob === 'function') bin = atob(t);
            else if (typeof Buffer !== 'undefined') bin = Buffer.from(t, 'base64').toString('latin1');
            else return null;
        } catch (e) { return null; }
        bin = bin.replace(/^\]d2/, '').replace(/^\x1d/, '');
        return /^01\d{14}21[\x1d\x21-\x7e]+$/.test(bin) ? bin : null;
    }

    function parse(input) {
        var b64 = fromBase64(input);
        if (b64) {
            var d = parse(b64);
            d.input = String(input);
            d.issues.unshift({ code: 'base64_decoded', level: 'info' });
            return d;
        }
        var r = parseOnce(input, false);
        /* Кириллица в коде — почти всегда сканер в русской раскладке. Тогда
           вся строка набрана в ней, и ЙЦУКЕН → QWERTY возвращает код точно.
           Принимаем исправление, только если оно дало код ИЗВЕСТНОГО состава:
           «молоко» в соседней ячейке не должно превращаться в «vjkjrj». */
        if (/[А-Яа-яЁё№]/.test(String(input == null ? '' : input)) && !(r.ok && r.structure)) {
            var f = parseOnce(input, true);
            if (f.ok && f.structure) return f;
        }
        return r;
    }

    function parseOnce(input, ruLayout) {
        var n = normalize(input);
        if (ruLayout) { n.raw = fromRuLayout(n.raw); n.notes.push('layout_fixed'); }
        var s = n.raw;
        var issues = [];
        n.notes.forEach(function (c) { issues.push({ code: c, level: 'info' }); });
        var res = { input: String(input == null ? '' : input), ok: false, code: null, fields: null, issues: issues };

        if (!s) { issues.push({ code: 'empty', level: 'error' }); return finish(res); }

        // Табачная пачка: 29 знаков без AI (14 GTIN + 7 + 4 МРЦ + 4) — её
        // печатает фабрика, и это не GS1-код.
        if (/^\d{14}[\x21-\x7e]{15}$/.test(s) && s.length === 29 && s.slice(0, 2) !== '01') {
            issues.push({ code: 'tobacco_pack', level: 'error' });
            return finish(res);
        }

        var fields = null, restored = false;
        if (s[0] === '(') {
            fields = fromParenthesized(s);
            if (fields) issues.push({ code: 'parentheses', level: 'info' });
        }
        var flat = fields ? null : s.split(GS).join('');
        if (!fields && !/^01\d{14}/.test(flat)) {
            issues.push({ code: 'not_code', level: 'error' });
            return finish(res);
        }

        if (!fields) {
            // 1) шаблон по длине и меткам — однозначно, если сошёлся;
            var hit = null;
            for (var i = 0; i < TEMPLATES.length && !hit; i++) {
                var m = matchTemplate(flat, TEMPLATES[i]);
                if (m) hit = m;
            }
            var withGs = s.indexOf(GS) >= 0;
            if (hit) {
                fields = hit;
                if (!withGs) { restored = true; }
            } else if (withGs) {
                // 2) разделители уже стоят — разбор по AI.
                fields = parseWithSeparators(s);
            }
        }

        if (!fields) {
            // Ни шаблон, ни разделители. Что именно не так — сказать точно.
            var diag = diagnose(flat);
            issues.push({ code: diag, level: 'error' });
            res.gtin = flat.slice(2, 16);
            return finish(res);
        }

        res.fields = fields;
        res.code = joinFields(fields);
        var canonIn = s;
        if (restored) issues.push({ code: 'gs_restored', level: 'info' });
        else if (s[0] !== '(' && canonIn !== res.code) issues.push({ code: 'gs_normalized', level: 'info' });

        var by = {};
        fields.forEach(function (f) { if (by[f.ai] == null) by[f.ai] = f.value; });
        res.gtin = by['01'] || null;
        res.serial = by['21'] != null ? by['21'] : null;
        res.key91 = by['91'] != null ? by['91'] : null;
        res.check92 = by['92'] != null ? by['92'] : null;
        res.check93 = by['93'] != null ? by['93'] : null;
        res.ki = res.gtin && res.serial != null ? '01' + res.gtin + '21' + res.serial : null;
        var tpl = templateOf(fields);
        res.structure = tpl ? tpl.id : null;
        res.template = tpl;

        if (!res.gtin || !/^\d{14}$/.test(res.gtin)) issues.push({ code: 'not_code', level: 'error' });
        else if (!gtinValid(res.gtin)) issues.push({ code: 'gtin_check', level: 'error' });
        if (res.serial == null) issues.push({ code: 'no_serial', level: 'error' });
        if (res.check92 == null && res.check93 == null) issues.push({ code: 'ki_only', level: 'error' });
        else if (res.check92 != null && res.key91 == null) issues.push({ code: 'no_key91', level: 'error' });
        if (!/^[\x1d\x21-\x7e]+$/.test(res.code)) issues.push({ code: 'bad_chars', level: 'error' });
        if (!tpl && !issues.some(function (x) { return x.level === 'error'; })) {
            issues.push({ code: 'unknown_structure', level: 'warn' });
        }
        return finish(res);
    }

    /* Почему длинная строка с GTIN не стала кодом: обрезанный криптохвост,
     * один КИ без кода проверки, лишние знаки — по самому близкому шаблону. */
    function diagnose(flat) {
        // Ближайший состав, у которого на своих местах стоят метки полей
        // ДАЛЬШЕ серийного (91/92/93/…) — значит, это код этой группы, и
        // разница в длине говорит, обрезан он или с лишними знаками.
        var best = null;
        for (var i = 0; i < TEMPLATES.length; i++) {
            var tf = TEMPLATES[i].fields, pos = 0, okHeads = true, tailHead = false, total = 0;
            for (var j = 0; j < tf.length; j++) {
                var ai = tf[j][0] === '335*' ? flat.substr(pos, 4) : tf[j][0];
                if (pos < flat.length) {
                    if (flat.substr(pos, ai.length) !== ai) { okHeads = false; break; }
                    if (j >= 2) tailHead = true;
                }
                pos += ai.length + tf[j][1];
                total = pos;
            }
            if (!okHeads || !tailHead) continue;
            var d = flat.length - total;
            if (best == null || Math.abs(d) < Math.abs(best.d)) best = { d: d, tpl: TEMPLATES[i] };
        }
        if (best && best.d < 0 && best.d >= -88) return 'crypto_truncated';
        if (best && best.d > 0 && best.d <= 6) return 'extra_chars';
        // КИ: 01 + GTIN + 21 + серийный 6/7/13/20, и ничего больше.
        if (/^01\d{14}21/.test(flat) && [24, 25, 31, 38].indexOf(flat.length) >= 0) return 'ki_only';
        // Серийный нестандартной длины (обрезан при копировании) и ни следа кода
        // проверки (91…92… или 93…) — для человека это то же «только КИ»:
        // печатать нельзя, нужен полный код.
        if (/^01\d{14}21/.test(flat) && flat.length <= 40 && !/91.{4}92|93.{4}$/.test(flat.slice(18))) return 'ki_only';
        return 'unknown_structure_bad';
    }

    function finish(res) {
        var lv = 'ok';
        res.issues.forEach(function (x) {
            if (x.level === 'error') lv = 'error';
            else if (x.level === 'warn' && lv !== 'error') lv = 'warn';
        });
        res.level = lv;
        res.ok = lv !== 'error' && !!res.code;
        return res;
    }

    /* ── из текста: построчно, ячейками таблицы ─────────────────────────────
     * Строка целиком — код (в нём бывают ; , " — поэтому сперва целиком).
     * Не вышло — это строка таблицы: делим по табуляции, ;, , с кавычками
     * CSV и берём ячейку, которая читается как код. Строки без единой цифры
     * (заголовки, пустые) пропускаются молча; похожие на код, но битые —
     * попадают в отчёт с номером строки. */
    function splitCells(line, d) {
        var out = [], cell = '', q = false;
        for (var i = 0; i < line.length; i++) {
            var c = line[i];
            if (q) {
                if (c === '"') { if (line[i + 1] === '"') { cell += '"'; i++; } else q = false; }
                else cell += c;
                continue;
            }
            if (c === '"' && cell === '') { q = true; continue; }
            if (c === d) { out.push(cell); cell = ''; continue; }
            cell += c;
        }
        out.push(cell);
        return out;
    }

    function extract(text, source) {
        // RS (0x1E) соединяет связанные коды в отчётах ЦРПТ — это граница кода, как перевод строки.
        var lines = String(text == null ? '' : text).replace(/\r\n?/g, '\n').replace(/\x1e/g, '\n').split('\n');
        var items = [], skipped = 0, bad = [];
        for (var li = 0; li < lines.length; li++) {
            var line = lines[li];
            if (!line.trim()) continue;
            /* Табуляции в коде не бывает — строка с ней всегда строка таблицы.
               Строку с ; или , сперва пробуем целиком (эти знаки бывают в
               серийном номере), но целиком принимаем только код ИЗВЕСТНОГО
               состава; иначе — ячейками. */
            var hasTab = line.indexOf('\t') >= 0;
            var hasDelim = hasTab || /[;,]/.test(line);
            var whole = hasTab ? null : parse(line);
            if (whole && whole.ok && (whole.structure || !hasDelim)) {
                items.push(tag(whole, source, li + 1));
                continue;
            }
            var picked = null;
            var delims = ['\t', ';', ','];
            for (var di = 0; di < delims.length && !picked; di++) {
                if (line.indexOf(delims[di]) < 0) continue;
                var cells = splitCells(line, delims[di]);
                if (cells.length < 2) continue;
                for (var ci = 0; ci < cells.length; ci++) {
                    var p = parse(cells[ci]);
                    if (p.ok) { picked = p; break; }
                }
            }
            if (!picked && whole && whole.ok) picked = whole;   // незнакомый состав, но код
            if (picked) { items.push(tag(picked, source, li + 1)); continue; }
            // Похоже на код (есть 01 и 14 цифр), но не читается — это ошибка партии.
            if (/0?1\d{14}/.test(line.replace(/[()\s]/g, ''))) {
                var e = tag(whole || bestCell(line), source, li + 1);
                items.push(e);
                bad.push(li + 1);
            } else skipped++;
        }
        return { items: items, skipped: skipped, badLines: bad };
    }

    /* Ячейка строки таблицы, больше всего похожая на код, — чтобы ошибка
       называла именно её. */
    function bestCell(line) {
        var cells = splitCells(line, '\t'), best = null;
        for (var i = 0; i < cells.length; i++) if (/01\d{14}/.test(cells[i])) { best = cells[i]; break; }
        return parse(best != null ? best : line);
    }

    function tag(p, source, line) { p.source = source || null; p.line = line || null; return p; }

    /* ── партия ─────────────────────────────────────────────────────────────
     * Вход — разобранные записи из всех файлов. Выход — что печатать и что
     * сказать человеку: дубли (между файлами и внутри), один КИ с разными
     * хвостами, счёт по GTIN, по файлам, по структуре. Порядок печати —
     * порядок входа, дубль печатается ОДИН раз. */
    function batch(items) {
        var seen = {}, kiSeen = {}, out = [], dups = [], kiConflicts = [];
        var byGtin = {}, bySource = {}, byStructure = {}, errors = 0, warns = 0;
        for (var i = 0; i < items.length; i++) {
            var it = items[i];
            var src = it.source || '';
            var bs = bySource[src] || (bySource[src] = { name: src, total: 0, ok: 0, errors: 0, dups: 0 });
            bs.total++;
            if (!it.ok) { errors++; bs.errors++; out.push({ item: it, printable: false }); continue; }
            if (seen[it.code] != null) {
                dups.push({ item: it, first: seen[it.code] });
                bs.dups++;
                continue;
            }
            if (it.ki && kiSeen[it.ki] != null && items[kiSeen[it.ki]].code !== it.code) {
                kiConflicts.push({ item: it, first: kiSeen[it.ki] });
                it.issues.push({ code: 'same_ki_other_tail', level: 'error' });
                it.level = 'error'; it.ok = false;
                errors++; bs.errors++;
                out.push({ item: it, printable: false });
                continue;
            }
            seen[it.code] = i;
            if (it.ki) kiSeen[it.ki] = i;
            if (it.level === 'warn') warns++;
            bs.ok++;
            var g = byGtin[it.gtin] || (byGtin[it.gtin] = { gtin: it.gtin, count: 0, structures: {} });
            g.count++;
            g.structures[it.structure || '?'] = 1;
            byStructure[it.structure || '?'] = (byStructure[it.structure || '?'] || 0) + 1;
            out.push({ item: it, printable: true });
        }
        var printable = out.filter(function (r) { return r.printable; }).map(function (r) { return r.item; });
        var gtins = Object.keys(byGtin).map(function (k) { return byGtin[k]; })
            .sort(function (a, b) { return b.count - a.count || (a.gtin < b.gtin ? -1 : 1); });
        // Окно модуля партии: самое строгое из структур, что в ней есть.
        var maxModule = 0.68;
        printable.forEach(function (p) { if (p.template && p.template.maxModule < maxModule) maxModule = p.template.maxModule; });
        if (printable.some(function (p) { return !p.template; })) maxModule = Math.min(maxModule, 0.615);
        return {
            total: items.length, printable: printable, rows: out,
            errors: errors, warns: warns, duplicates: dups, kiConflicts: kiConflicts,
            gtins: gtins, sources: Object.keys(bySource).map(function (k) { return bySource[k]; }),
            structures: byStructure, maxModule: maxModule,
        };
    }

    /* Группы, чей состав совпадает со структурой — для подсказки «что это за
     * код». По одному коду группу не узнать (GTIN её не несёт), поэтому это
     * список, а не ответ. */
    function groupsFor(structureId) {
        for (var i = 0; i < TEMPLATES.length; i++) if (TEMPLATES[i].id === structureId) return TEMPLATES[i].groups.slice();
        return [];
    }

    /* ── выгрузка для 1С / МойСклада ────────────────────────────────────────
     * Полный код в трёх видах: с GS, записанным как «\x1D» (видно глазом и не
     * теряется при копировании), Base64 (байт в байт, так полные коды хранят
     * учётные системы) и, в TXT, — с настоящим байтом GS. Поля в кавычках,
     * разделитель «;» (русский Excel); серийный номер, начинающийся с = + - @,
     * получает апостроф — иначе Excel откроет его как формулу. */
    function b64(s) {
        var tbl = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        var out = '', i = 0;
        for (; i + 2 < s.length; i += 3) {
            var n = (s.charCodeAt(i) << 16) | (s.charCodeAt(i + 1) << 8) | s.charCodeAt(i + 2);
            out += tbl[(n >> 18) & 63] + tbl[(n >> 12) & 63] + tbl[(n >> 6) & 63] + tbl[n & 63];
        }
        var rest = s.length - i;
        if (rest === 1) { var a = s.charCodeAt(i) << 16; out += tbl[(a >> 18) & 63] + tbl[(a >> 12) & 63] + '=='; }
        else if (rest === 2) { var b = (s.charCodeAt(i) << 16) | (s.charCodeAt(i + 1) << 8); out += tbl[(b >> 18) & 63] + tbl[(b >> 12) & 63] + tbl[(b >> 6) & 63] + '='; }
        return out;
    }
    function escapeGs(code) { return String(code).split(GS).join('\\x1D'); }
    function q(v) { return '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"'; }
    function safeCell(v) { v = String(v == null ? '' : v); return /^[=+\-@]/.test(v) ? "'" + v : v; }

    function toCsv(items, opts) {
        opts = opts || {};
        var h = opts.headers || ['N', 'GTIN', 'Serial', 'KI', 'Code (GS as \\x1D)', 'Code Base64', 'File', 'Printed'];
        var lines = [h.map(q).join(';')];
        for (var i = 0; i < items.length; i++) {
            var it = items[i];
            lines.push([i + 1, it.gtin, safeCell(it.serial), it.ki, escapeGs(it.code), b64(it.code), it.source || '',
                opts.printed && opts.printed(it) ? opts.printedMark || '1' : ''].map(q).join(';'));
        }
        return '\uFEFF' + lines.join('\r\n') + '\r\n';
    }
    function toTxt(items) {
        return items.map(function (it) { return it.code; }).join('\r\n') + '\r\n';
    }
    function gtinCsv(b, opts) {
        opts = opts || {};
        var h = opts.headers || ['GTIN', 'Count', 'Name'];
        var lines = [h.map(q).join(';')];
        b.gtins.forEach(function (g) {
            lines.push([g.gtin, g.count, opts.nameOf ? opts.nameOf(g.gtin) || '' : ''].map(q).join(';'));
        });
        return '\uFEFF' + lines.join('\r\n') + '\r\n';
    }

    /* Человекочитаемая подпись под кодом: КИ двумя строками, как на этикетке
     * ЧЗ. Криптохвост текстом не печатают (он не нужен глазу и путает). */
    function kiLines(it) {
        if (!it || !it.gtin) return ['', ''];
        return ['(01)' + it.gtin, '(21)' + (it.serial || '')];
    }

    /* Хэш строки для ключа капа и пометок «напечатано» (FNV-1a 32 бита,
     * в hex) — не криптография, а короткое имя записи. */
    function hash(s) {
        var h = 0x811c9dc5;
        s = String(s);
        for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
        return ('0000000' + h.toString(16)).slice(-8);
    }

    return {
        GS: GS,
        TEMPLATES: TEMPLATES,
        normalize: normalize,
        fromRuLayout: fromRuLayout,
        parse: parse,
        extract: extract,
        batch: batch,
        groupsFor: groupsFor,
        gtinValid: gtinValid,
        gtinCheckDigit: gtinCheckDigit,
        needsSeparator: needsSeparator,
        joinFields: joinFields,
        toCsv: toCsv,
        toTxt: toTxt,
        gtinCsv: gtinCsv,
        b64: b64,
        escapeGs: escapeGs,
        kiLines: kiLines,
        hash: hash,
        splitCells: splitCells,
    };
});
